import api from "../../services/api"

export const FETCH_ADDADDRESS_FULFILLED = "FETCH_ADDADDRESS_FULFILLED";
export const FETCH_ADDADDRESS_REJECTED = "FETCH_ADDADDRESS_REJECTED";
export const FETCH_ADDADDRESS_PENDING = "FETCH_ADDADDRESS_PENDING";
export const RESET_ADDADDRESS = "RESET_ADDADDRESS";

export function addAddress(address, isDefault, addressType, customName) {
  return (dispatch) => {
      dispatch({ type: FETCH_ADDADDRESS_PENDING });
      api.post("/gate/users/address/add", { address, isDefault, addressType, customName })
          .then(response => {
              dispatch({
                  type: FETCH_ADDADDRESS_FULFILLED,
                  payload: response.data,
              });
          })
          .catch(error => {
              dispatch({
                  type: FETCH_ADDADDRESS_REJECTED,
                  payload: error,
              });
          });
  };
}

export function resetAddAddress() {
  return (dispatch) => {
      dispatch({
          type: RESET_ADDADDRESS,
      });
  };
}